import {newStepValue} from '../../../../services/flowBuilder/utils/constants';

export const dynamicList = {
    json: {
        menu: {
            menuType: 'dynamicList',
            menuHeader: '',
            bodyText: '', // message to user
            menuParams: {
                groupTitle: '', // sub header
                optionSeperator: ". ",
                optionPattern: '',
                displayTypes: {},
                valuePattern: '',
                filterBy: {},
                exclude: {},
            },
            input: {
                varName: '',
                isPrivateVariable: false
            },
            results: {
                success: {
                    next: newStepValue,
                },
                error: {
                    next: newStepValue,
                },
            },
        },
        type: 'menu',
        next: newStepValue,
    },
};
